import React, { useEffect, useState } from "react";
import { Tag } from "antd";
import { useUserBranches } from "../../hooks/accessControl";

const PatientBranch = (props) => {
  const { record } = props;
  const [branchName, setBranchName] = useState("");
  const userBranches = useUserBranches();

  useEffect(() => {
    const branch = userBranches.filter((i) => i.id === record.branch_id)[0];
    if (branch) {
      setBranchName(branch.name);
    }
  }, [userBranches, record.branch]);

  return (
    <div>
      <Tag>{branchName}</Tag>
    </div>
  );
};

export default PatientBranch;
